import { RecordCheckData, VinregType } from "../dataLayerEvents.types";
import type { RecordCheckStore } from "stores/recordCheck.store";

const getVinregType = (vinreg?: string): VinregType | undefined => {
  if (!vinreg) {
    return undefined;
  }
  return vinreg.length < 10 ? VinregType.LICENSE_PLATE : VinregType.VIN;
};

const getRecordCheckData = (recordCheckStore: RecordCheckStore): RecordCheckData => {
  const vinreg = recordCheckStore.isEncrypted ? recordCheckStore.encryptedQuery : recordCheckStore.query;
  return {
    vinregType: getVinregType(vinreg),
    vinRecords: recordCheckStore.reportDataTotal,
    reportCombination: recordCheckStore.reportCombination,
    vinregSearchType: recordCheckStore.vinregSearchType,
  };
};

export const dataLayerUtil = {
  getVinregType,
  getRecordCheckData,
};
